import React from 'react';
import { GlobeIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-[#0B0B12] py-12 border-y border-white/5 relative overflow-hidden" data-id="element-312">
      <div className="blur-circle bg-brand-blueDeep/10 -top-20 -left-20 opacity-30" data-id="element-313" />
      <div className="max-w-4xl mx-auto px-5 relative z-10" data-id="element-314">
        <p className="text-center text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] mb-10" data-id="element-315">
          CONFIADO POR PROFESIONALES DE BELLEZA Y PELUQUERÍA
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-316">
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-317" />
          <StatItem value="6" label="BONOS GRATIS" data-id="element-318" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-319" />
          <StatItem value={<GlobeIcon size={40} className="text-brand-gold" data-id="element-321" />} label="Argentina y Latinoamérica" isIcon data-id="element-320" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 mt-10 pt-8 border-t border-white/10" data-id="element-322">
          <span className="text-sm text-slate-400 font-black uppercase tracking-widest" data-id="element-323">
            📄 100% digital (PDF)
          </span>
          <span className="text-sm text-slate-400 font-black uppercase tracking-widest" data-id="element-324">
            ⚡ Acceso inmediato
          </span>
          <span className="text-sm text-slate-500 font-bold text-center w-full mt-2 max-w-2xl mx-auto leading-relaxed" data-id="element-325">
            🧠 Diseñado para profesionales que ya saben trabajar… pero quieren
            dejar de improvisar su operación diaria.
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isIcon
}: {
  value: string | React.ReactNode;
  label: string;
  isIcon?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center" data-id="element-326">
      <div className={`${isIcon ? 'mb-2' : 'text-3xl md:text-5xl font-black gold-text-gradient mb-2 tracking-tighter'}`} data-id="element-327">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-slate-500 font-black uppercase tracking-[0.2em] leading-tight max-w-[120px]" data-id="element-328">
        {label}
      </div>
    </div>;
}